if (!customElements.get('variant-picker')) {
  customElements.define(
    'variant-picker',
    class VariantPicker extends HTMLElement {
      constructor() {
        super();
        this.options = this.querySelectorAll('[data-option]');
        this.buyButtonsWrapper = document.querySelector(`#${this.productFormId} [data-buy-buttons-wrapper]`);
        this.bisWrapper = document.querySelector(`#${this.productFormId} #klaviyo-bis-trigger-wrapper`);
      }

      get productFormId() {
        return this.dataset.formId;
      }

      connectedCallback() {
        this.setvariant();
      }

      setvariant() {
        if (this.options.length === 0) return;
        this.options.forEach((option) =>
          option.addEventListener('click', () => {
            this.options.forEach((option) => option.classList.remove('active'));
            option.classList.add('active');
            const formInput = document.querySelector(`input[name="id"][form="${this.productFormId}"]`);
            if (!formInput) return;
            const variantId = option.dataset.option;

            if (option.hasAttribute('data-sold')) {
              if (this.buyButtonsWrapper && this.bisWrapper) {
                this.toggleBis(true);
              }
            } else {
              formInput.value = variantId;
              this.updateHistoryState(variantId);
              if (this.buyButtonsWrapper && this.bisWrapper) {
                this.toggleBis();
              }
            }
          })
        );
      }

      updateHistoryState(variantId) {
        if (!variantId) return;
        const location = window.location.href;
        if (variantId && location.includes('/product')) {
          const url = new window.URL(location);
          const params = url.searchParams;
          params.set('variant', variantId);
          url.search = params.toString();
          const urlString = url.toString();
          window.history.replaceState({ path: urlString }, '', urlString);
        }
      }

      toggleBis(state) {
        if (window.location.href.includes('/products/')) {
          state
            ? (this.bisWrapper.removeAttribute('style'), (this.buyButtonsWrapper.style.display = 'none'))
            : ((this.bisWrapper.style.display = 'none'), (this.buyButtonsWrapper.style.display = 'grid'));
        } else if (window.location.href.includes('/collections/')) {
          const buttonHandle = this.bisWrapper.dataset.klaviyoHandle;
          const originalButton = document.querySelector(`#klaviyo-data-handle-${buttonHandle}`);
          if (!originalButton) return;

          const buttonCopy = originalButton.cloneNode(true);
          const buttonCopyContainer = buttonCopy.querySelector('.klaviyo-button-container');
          if (buttonCopyContainer) {
            buttonCopyContainer.removeAttribute('style');
          }
          if (!this.bisWrapper.querySelector(`#klaviyo-data-handle-${buttonHandle}`)) {
            this.bisWrapper.insertAdjacentElement('beforeend', buttonCopy);
          }
          state
            ? (this.bisWrapper.removeAttribute('style'), (this.buyButtonsWrapper.style.display = 'none'))
            : ((this.bisWrapper.style.display = 'none'), (this.buyButtonsWrapper.style.display = 'grid'));
        }
      }
    }
  );
}
